export const ProjectStatus = {
  Unpublished: "Unpublished",
  Published: "Published",
  Closed: "Closed",
  Awarded: "Awarded",
  NotAwarded: "Not Awarded",
  NoCooperation: "No Cooperation",
  Withdrawn: "Withdrawn",
};
